import { render, staticRenderFns } from "./GiftsPurchasesTable.vue?vue&type=template&id=bc22c304&"
import script from "./GiftsPurchasesTable.vue?vue&type=script&lang=ts&"
export * from "./GiftsPurchasesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports